import { FormSectionHandler } from '../entity.handler';
import { ZoneResponse, ZoneUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { ComboField, EnumToFormBuilderComboValues, NumberField } from '../utils';
import { SpatialUtils } from 'app/shared/components/map/map.utils';
import { MeasurementUnitsService } from 'app/services';

interface EditorValues {
    lat?: number;
    lon?: number;
    shape?: string;
    radius?: number;
}

export class ZoneCoordsSectionHandler implements FormSectionHandler<ZoneResponse, EditorValues> {

    type = 'form';
    icon = 'map-pin';
    bulk = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        private units: MeasurementUnitsService,
        public ownerId: string
    ) {
    }

    private shapes = ['triangle', 'square', 'hexagon', 'octagon'];
    private shapePoints = [3, 4, 6, 8];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ZONE.COORDS.${key}`, values);
    }

    applyUpdate(entity: ZoneResponse, payload: ZoneUpdateRequest): Promise<ZoneResponse> {
        return this.admin.applyUpdate(api => api.entities.updateZone(entity.id, payload), { _type: 'zone' });
    }

    mapEntityToEditor(_entity: ZoneResponse): Promise<EditorValues> {
        return Promise.resolve({
            shape: 'square',
            radius: this.units.fromBackend('distance', 0.150, 3), // kilometers
        });
    }

    mapEditorToEntity(entity: ZoneUpdateRequest, values: EditorValues): Promise<ZoneUpdateRequest> {
        const radius = this.units.toBackend('distance', values.radius) as number;
        entity.points = SpatialUtils.generateRegularPolygon({ x: values.lon, y: values.lat }, radius, this.shapePoints[this.shapes.indexOf(values.shape)]);
        return Promise.resolve(entity);
    }

    getFields(_entity: ZoneResponse): Promise<FormBuilderField[]> {
        return Promise.resolve([
            NumberField('lat', this.translate('FIELDS.LATITUDE'), true, -90, 90, null),
            NumberField('lon', this.translate('FIELDS.LONGITUDE'), true, -180, 180, null),
            ComboField('shape', this.translate('FIELDS.SHAPE'), true,  EnumToFormBuilderComboValues(this.admin.i18n, 'ADMIN.EDITORS.ZONE.COORDS.SHAPES', this.shapes)),
            NumberField('radius', this.translate('FIELDS.RADIUS'), true, -180, 180, this.units.format(0, 'distance').unit),
        ]);
    }

}
